import FormTextArea from "../base/FormTextArea";

export default class TextArea extends FormTextArea {

    render() {
        return super.render();
    }
}